import { toast } from 'react-toastify';

/** Single id so report pages don’t stack multiple “Generating…” toasts */
export const REPORT_GENERATING_TOAST_ID = 'report-generating';

/**
 * Show React-Toastify loading toast (replaces inline spinner + “Generating…” in buttons).
 */
export function showReportGeneratingToast(message = 'Generating report…') {
  return toast.loading(message, {
    toastId: REPORT_GENERATING_TOAST_ID,
    position: 'top-right',
    closeButton: false,
    draggable: false,
  });
}

export function dismissReportGeneratingToast() {
  toast.dismiss(REPORT_GENERATING_TOAST_ID);
}

/** Call after successful fetch when a loading toast was shown */
export function reportGenerationDone(successMessage) {
  dismissReportGeneratingToast();
  if (successMessage) {
    toast.success(successMessage, { autoClose: 2200 });
  }
}

/** Call after failed fetch when a loading toast was shown */
export function reportGenerationFailed(message) {
  dismissReportGeneratingToast();
  if (message) {
    toast.error(message, { autoClose: 5000 });
  }
}
